/**
 * CtcValue — renders a CTC field honoring rule R6.
 * - key ABSENT (unauthorized) → 🔒 Restricted chip.
 * - key present but null      → em dash (not provided).
 * - number                    → ₹ Indian formatting.
 */

import React from 'react';
import type { Candidate } from '../../../services/recruitmentApi';
import { formatINR } from '../../../utils/currencyFormatter';
import { ctcIsRestricted } from '../utils/format';
import { RestrictedChip } from './badges';

export const CtcValue: React.FC<{ candidate: Candidate; field: 'current_ctc' | 'expected_ctc' }> = ({ candidate, field }) => {
	if (ctcIsRestricted(candidate, field)) return <RestrictedChip />;
	const value = candidate[field];
	if (value === null || value === undefined) return <span className='text-gray-400'>—</span>;
	return <span className='font-medium text-gray-900'>{formatINR(Number(value))}</span>;
};
